export default {
  primary: process.env.REACT_APP_PRIMARY_COLOR,
  secondary: process.env.REACT_APP_SECUNDARY_COLOR,
  text_color: process.env.REACT_APP_LOGIN_TEXT_COLOR,
  danger: '#e84d4d',
  warning: '#e8c24d',
  success: '#4de86c'
}



// WEBPACK FOOTER //
// ./src/utils/color.js